<template>
    <SiteHeader></SiteHeader>

    <div class="flex flex-start container">
        <TabsMain
                :current="currentRouteName"
                :userName="userName"
        ></TabsMain>

        <Button class="btn-add-trim" @click="openAddTrimModal"><i class="icon-plus"></i> Add trim</Button>
    </div>

    <CreateNewTrimModal v-if="displayAddTrimModal" @closeModal="closeAddTrimModal"></CreateNewTrimModal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CreateNewTrimModal from "../../components/modals/CreateNewTrimModal";
    import TabsMain from "./TabsMain";
    import Button from "../../components/Button";
    import SiteHeader from "../../components/SiteHeader";


    export default {
        name: "HeaderMain",

        components: {
            SiteHeader,
            Button,
            TabsMain,
            CreateNewTrimModal
        },

        props: [
            'currentRouteName',
            'autoOpenAddTrim',
        ],

        data() {
            return {
                displayAddTrimModal: false,
            }
        },

        mounted() {
            // Auto-open Add Trim modal if requested
            if (this.autoOpenAddTrim) {
                this.$nextTick(() => {
                    this.openAddTrimModal();
                });
            }
        },

        computed: {
            ...mapGetters('users', [
                'currentUser',
            ]),

            ...mapGetters('authentication', [
                'hasUserAccess',
            ]),

            userName() {
                return this.currentUser?.userName || '';
            },

        },

        methods: {
            openAddTrimModal() {
                this.displayAddTrimModal = true;
            },

            closeAddTrimModal() {
                this.displayAddTrimModal = false;
            },

        },

    }
</script>

<style scoped>
    .flex {
        align-items: flex-start;
    }

    .btn-add-trim {
        margin-left: auto;
        background: #808080;
    }

    .btn-add-trim:hover {
        background: #6f6f6f;
    }
</style>